'use client';
import { usePathname } from 'next/navigation';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './globals.css';
import Providers from './providers';
import UserAuthorize from './UserAuthorize';

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathName = usePathname();
  return (
    <html lang="en" className="bg-green-50">
      <body>
        {pathName === '/auth' ? (
          children
        ) : (
          <Providers>
            <UserAuthorize>{children}</UserAuthorize>
          </Providers>
        )}

        <ToastContainer />
      </body>
    </html>
  );
}
